import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Paper,
  Typography,
  Stack,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
} from '@mui/material';
import {
  Language as LanguageIcon,
  Security as SecurityIcon,
  People as PeopleIcon,
  Notifications as NotificationsIcon,
} from '@mui/icons-material';

const Settings: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {t('navigation.settings')}
      </Typography>

      <Stack spacing={3} sx={{ mt: 3 }}>
        <Paper>
          <List>
            <ListItem>
              <ListItemIcon>
                <LanguageIcon />
              </ListItemIcon>
              <ListItemText primary="Language & Localization" />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText primary="Security Settings" />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="User Management" />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <NotificationsIcon />
              </ListItemIcon>
              <ListItemText primary="Notifications" />
            </ListItem>
          </List>
        </Paper>

        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            System Information
          </Typography>
          <Stack spacing={1}>
            <Typography variant="body2">
              <strong>Version:</strong> 1.0.0
            </Typography>
            <Typography variant="body2">
              <strong>Backend:</strong> Strapi v4.20
            </Typography>
            <Typography variant="body2">
              <strong>Frontend:</strong> React 18 + TypeScript
            </Typography>
            <Typography variant="body2">
              <strong>API URL:</strong> {process.env.REACT_APP_API_URL || 'https://darb.aiastra.io'}
            </Typography>
          </Stack>
        </Paper>

        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Quick Links
          </Typography>
          <Stack spacing={1}>
            <Typography variant="body2">
              <strong>Strapi Admin:</strong>{' '}
              <a href="https://darb.aiastra.io/admin" target="_blank" rel="noopener noreferrer">
                https://darb.aiastra.io/admin
              </a>
            </Typography>
            <Typography variant="body2">
              <strong>API Documentation:</strong> Available in Strapi Admin
            </Typography>
            <Typography variant="body2">
              <strong>Support:</strong> Check documentation files in project root
            </Typography>
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
};

export default Settings;

